<template>
    <b-modal id="disability-form-modal" ref="disabilityFormModal"
             :title="$t(`평가 신청 관련 문의하기`)"
             size="lg"
             hide-footer
             centered
    >
        <!-- @hidden="onDisabilityHidden" -->
        <!-- hide-header -->
        <div class="text-center">
            <p class="f-110 font-weight-bold mt-3 mb-4">{{ $t('아래 사항을 입력해주시면 최대한 빠르게 해결 도와드리겠습니다.') }}</p>
        </div>
        <div class="group-inputs">
            <b-row class="mb-3">
                <b-col cols="6">
                    <div class="gray-600 mb-1"> {{ $t(`성함`) }} *</div>
                    <b-form-input v-model="regDisabilityForm.name" type='text'></b-form-input>
                </b-col>
                <b-col cols="6">
                    <div class="gray-600 mb-1">{{ $t(`소속`) }} *</div>
                    <b-form-input v-model="regDisabilityForm.company" type='text'
                                  :placeholder="$t('회사')"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col cols="6">
                    <div class="gray-600 mb-1">{{ $t(`연락처`) }} *</div>
                    <b-form-input v-model="regDisabilityForm.contact" type='text'></b-form-input>
                </b-col>
                <b-col cols="6">
                    <div class="gray-600 mb-1">{{ $t(`이메일`) }} *</div>
                    <b-form-input v-model="regDisabilityForm.email" type='text'
                                  placeholder="name@example.com"></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" class="mb-3">
                    <div class="gray-600 mb-1">{{ $t(`문의사항`) }} *</div>
                    <b-textarea v-model="regDisabilityForm.message" rows="6"
                                :placeholder="$t(`업체 코드(vendor code)를 기입 후 문의해 주시면 빠른 확인 가능합니다. 문의사항을 작성해 주세요.`)"></b-textarea>
                </b-col>
                <b-col v-if="!loadingSendMail" cols="12" class="text-right">
                    <b-btn variant="danger" @click="closeModal">{{ $t('취소') }}</b-btn>
                    <b-button class="ml-2" variant="blue" @click="sendCustomerServiceToFailRegister">
                        {{ $t(`문의하기`) }}
                        <fa icon="paper-plane" class="ml-1"></fa>
                    </b-button>
                </b-col>
                <b-col v-else cols="12" class="text-center">
                    <b-spinner size="small"></b-spinner>
                    {{ $t(`문의사항을 전송하는 중입니다. 잠시 기다려 주세요.`) }}
                </b-col>
            </b-row>
        </div>
    </b-modal>

</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'DisabilityFormModal',
    data() {
        return {
            regDisabilityForm: {
                name: '',
                company: '',
                contact: '',
                email: '',
                message: ''
            },
            loadingSendMail: false
        };
    },
    computed: {
        ...mapState('register', ['is_conflict_register', 'selected_vendor']),
    },
    watch: {
        is_conflict_register(status) {
            if (status) {
                this.regDisabilityForm = {
                    name: null,
                    company: this.selected_vendor?.company?.company_name || null,
                    email: null,
                    contact: null,
                    message: '업체 코드(vendor code)를 기입 후 문의해 주시면 빠른 확인 가능합니다.'
                };

                this.$nextTick(() => {
                    this.$refs.disabilityFormModal.show();
                });
            } else {
                this.regDisabilityForm = {
                    name: null,
                    company: null,
                    email: null,
                    contact: null,
                    message: '업체 코드를 기입 후 문의해 주시면 빠른 확인 가능합니다.'
                };
            }
        },
    },
    methods: {
        async sendCustomerServiceToFailRegister() {
            const isValidated = this.validateDisabilityForm();
            if (!isValidated) return;

            try {
                this.loadingSendMail = true;
                // const path = this.$store.state.backend_host + '/save_customer_service'
                const {name, company, email, contact, message} = this.regDisabilityForm;

                let formData = new FormData;
                formData.append('name', name);
                formData.append('company', company);
                formData.append('mobile', contact);
                formData.append('e_mail', email);
                formData.append('requirements', message);
                formData.append('source', 'qesg_assessment');

                await this.$axios.post('/save_customer_service', formData);
                this.$EventBus.$emit('toast-success', this.$t('알림'), this.$t('장애사항을 접수하였습니다. 최대한 빠르게 답변드리도록 하겠습니다.'));

                await this.$axios.post('/send_customer_service_mail', formData);
                this.closeModal();
            }
            catch (e) {
                // ignore
            }
            finally {
                this.loadingSendMail = false;
            }
        },
        validateDisabilityForm() {
            const {name, company, contact, email, message} = this.regDisabilityForm;
            if (!name) {
                alert('평가신청을 도와드릴 수 있도록 담당자분의 성함을 입력해주세요.');
                return false;
            }

            if (!company) {
                alert('평가신청을 도와드릴 수 있도록 회사 이름을 입력해주세요.');
                return false;
            }

            if (!contact && !email) {
                alert('평가신청을 도와드릴 수 있도록 연락처 또는 이메일 중 1개는 적어주셔야합니다.');
                return false;
            }

            if (!message) {
                alert('문의사항을 기입해주시면 감사하겠습니다.');
                return false;
            }

            return true;
        },
        closeModal(){
            if (this.$refs.disabilityFormModal) {
                this.$refs.disabilityFormModal.hide();
            }
        }
    }
};
</script>

<style lang="scss" scoped>

</style>
